import React, { Component } from 'react';
import ContentDashboard from "../content-dashboard";
import NotFound from "../not-found";
import { Switch } from 'react-router-dom';
import AuthHelper from "../../../libraries/auth-helper";
import { PrivateRoute } from '../../../libraries/route-handling'
import { bindActionCreators } from "redux";
import { RootActions } from "../../../shared/root-action";
import { connect } from "react-redux";
import { history } from "../../../shared/configure-store";
import Products from '../products';
import ProductsAdd from '../products/add';
import ProductsEdit from '../products/edit';
import ProductsDetail from '../products/detail';
import Reservations from '../reservations';
import ReservationsDetail from '../reservations/detail';
import Orders from '../orders';
import OrdersAdd from '../orders/add';
import Print from '../reservation/print';
import Sidebar from '../sidebar';
import Navbar from '../navbar';
import Histories from '../histories';
import Transactions from '../histories/transactions';
import Topup from '../histories/topup';
import HistoryDetail from '../histories/detail';
import InvoiceDetail from '../histories/invoice';
import Copyright from '../../presentational/copyright';
import ReservationsAdd from '../reservations/add'
import Inventories from '../inventories'

class Dashboard extends Component {

    constructor(props) {

        super(props);

    }

    componentDidMount() {
        if (AuthHelper.isLoggedIn()) {
            let profile = AuthHelper.getProfile();

            let user = JSON.parse(JSON.stringify(profile));

            this.props.setProfile(user);
        } else {
            history.push('/login');
        }
    }

    render() {
        const { location } = this.props;

        return (
            <div>
                <main className="dashboard container-fluid">
                    <div className='row'>
                        <div className='col-md pr-md-0' style={{ maxWidth: '270px' }}>
                            <Sidebar />
                        </div>
                        <div className='col-md pl-md-0 custom-max-width'>
                            <Navbar />
                            <section className='section-dashboard'>
                                <div className='main-container'>
                                    <Switch>
                                        <PrivateRoute exact path='/' component={ContentDashboard} />
                                        <PrivateRoute exact path='/products' component={Products} />
                                        <PrivateRoute path='/products/add' component={ProductsAdd} />
                                        <PrivateRoute path='/products/edit/:id' component={ProductsEdit} />
                                        <PrivateRoute path='/products/detail/:id' component={ProductsDetail} />
                                        <PrivateRoute exact path='/reservations' component={Reservations} />
                                        <PrivateRoute path='/reservations/detail/:id' component={ReservationsDetail} />
                                        <PrivateRoute exact path='/orders' component={Orders} />
                                        <PrivateRoute exact path='/orders/add' component={OrdersAdd} />
                                        <PrivateRoute exact path='/print' component={Print} />
                                        <PrivateRoute exact path='/histories' component={Histories} />
                                        <PrivateRoute exact path='/inventories' component={Inventories} />
                                        <PrivateRoute path='/histories/list' component={Transactions} />
                                        <PrivateRoute path='/histories/topup' component={Topup} />
                                        <PrivateRoute path='/histories/detail/:date' component={HistoryDetail} />
                                        <PrivateRoute path='/histories/invoice/:date' component={InvoiceDetail} />


                                        {/*<PrivateRoute exact path='/reservations' component={Reservations} />*/}
                                        <PrivateRoute exact path='/reservations/add' component={ReservationsAdd} />

                                        <PrivateRoute component={NotFound} />
                                    </Switch>
                                </div>
                            </section>
                        </div>
                    </div>
                </main>

                <footer className='dashboard-footer'>
                    <p className='mb-0'><Copyright /></p>
                </footer>


            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);

